export const SITE = {
  name: "Sabor Latino",
  phone: "(616) 247-3560",
  tel: "tel:+16162473560",
  street: "825 Cesar E. Chavez Ave SW",
  cityLine: "Grand Rapids, MI 49503",
  address: "825 Cesar E. Chavez Ave SW, Grand Rapids, MI 49503",
  directions:
    "https://www.google.com/maps/dir/?api=1&destination=825+Cesar+E.+Chavez+Ave+SW,+Grand+Rapids,+MI+49503",
  mapEmbed:
    "https://maps.google.com/maps?q=Sabor+Latino,+825+Cesar+E.+Chavez+Ave+SW,+Grand+Rapids,+MI+49503&z=16&output=embed",
  rating: "4.8",
  reviews: 108,
  twitter: "https://twitter.com/saborlatinogr",
  twitterHandle: "@saborlatinogr",
  facebook: "https://www.facebook.com/385764758182149",
  facebookLabel: "Sabor Latino",
};

export const HOURS = [
  { day: "Monday", short: "Mon", open: true },
  { day: "Tuesday", short: "Tue", open: true },
  { day: "Wednesday", short: "Wed", open: true },
  { day: "Thursday", short: "Thu", open: true },
  { day: "Friday", short: "Fri", open: true },
  { day: "Saturday", short: "Sat", open: true },
  { day: "Sunday", short: "Sun", open: false },
];

export const MENU = [
  {
    id: "meats",
    es: "Carnes",
    en: "Meats",
    note: "Include any side",
    img: "/images/plate-chicken.jpg",
    items: ["Baked Chicken", "Beef Steak", "Chicken Steak", "Stew Chicken"],
  },
  {
    id: "sides",
    es: "Arroz y Acompañantes",
    en: "Rice & Sides",
    note: "Pick one with any meat",
    img: "/images/bowl.jpg",
    items: ["White Rice and Beans", "Rice with Gandules", "Yellow Rice"],
  },
  {
    id: "goodies",
    es: "Picaderas",
    en: "Goodies",
    note: "Little bites, big flavor",
    img: "/images/empanadas.jpg",
    items: [
      "Beef Pie",
      "Chicken Pie",
      "Potato Balls filled with meat",
      "Tostones (fried plantains)",
      "Maduros (fried sweet plantains)",
    ],
  },
  {
    id: "juices",
    es: "Jugos Naturales",
    en: "Juices",
    note: "Made to wash it all down",
    img: "/images/parcha.jpg",
    items: ["Passion Fruit / Parcha", "Lemonade", "Morisoñando", "Horchata"],
  },
];
